"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopFrontKit = void 0;
var common_1 = require("@terra-js/common");
var ShopFrontKit = /** @class */ (function () {
    function ShopFrontKit() {
        this.GET_SCREEN_CONFIG_COMMAND = 'getScreenConfig';
        this.SHOULD_HANDLE_BACK_COMMAND = 'shouldHandleBack';
        this.HANDLE_BACK_COMMAND = 'handleBack';
        this.wrappedModule = null;
        this.shouldLog = false;
        this.wrappedModule = new common_1.ModuleWrapper('ShopFrontKitModule');
    }
    ShopFrontKit.prototype.setLogging = function (enable) {
        this.shouldLog = enable;
    };
    ShopFrontKit.prototype.log = function (message, obj) {
        if (this.shouldLog) {
            console.log("[ShopFrontKitModule] " + message + " " + JSON.stringify(obj));
        }
    };
    ShopFrontKit.prototype.shouldHandleBack = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke(_this.SHOULD_HANDLE_BACK_COMMAND)
                .then(function (response) {
                _this.log(_this.SHOULD_HANDLE_BACK_COMMAND, response);
                if (response.status_code == 200) {
                    resolve(response.result.shouldHandleBack);
                }
                else {
                    resolve(false);
                }
            });
        });
    };
    ShopFrontKit.prototype.handleBack = function () {
        this.wrappedModule.invoke(this.HANDLE_BACK_COMMAND).then();
    };
    ShopFrontKit.prototype.getScreenConfig = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.wrappedModule
                .invoke(_this.GET_SCREEN_CONFIG_COMMAND, { screen: window.location.pathname })
                .then(function (response) {
                _this.log(_this.GET_SCREEN_CONFIG_COMMAND, response);
                if (response.status_code == 200) {
                    resolve(response.result);
                }
                else {
                    resolve(undefined);
                }
            });
        });
    };
    return ShopFrontKit;
}());
exports.ShopFrontKit = ShopFrontKit;
